exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "highchart {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/highcharts-ng/dist/highcharts-ng.css
// module id = 1117
// module chunks = 12